(function () {
    'use strict';

    angular
        .module('franchisee-portal.filters')
        .filter('momentTimeAgo', momentTimeAgo)

    function momentTimeAgo() {
        function momentTimeAgoFn(value) {
            moment.locale('pt-br');

            var dateValue;

            if (!value)
                return '';

            dateValue = moment(value);

            if (!dateValue.isValid())
                return '';

            return dateValue.fromNow();
        }

        return momentTimeAgoFn;
    }
}());